<div class="paging-container">
    <div class="buttons">
        @if (sequentialPaging) {

        @if (items.length && (currentPage > 1 || hasNextPage)) {
            <button class="arrow-btn" mat-icon-button (click)="loadPrevPage()" [disabled]="loading || currentPage === 1">
                <mat-icon class="arrow pl-4">arrow_back_ios</mat-icon>
            </button>

            <div class="pages">
                <span class="page-number current-page">{{ currentPage }}</span>
            </div>

            <button class="arrow-btn" mat-icon-button (click)="loadNextPage()" [disabled]="loading || !hasNextPage">
                <mat-icon class="arrow">arrow_forward_ios</mat-icon>
            </button>
        }

        } @else {

        @if (items.length && totalPagesCount > 1) {

        @if (currentPage > 1) {
        <button class="arrow-btn" mat-icon-button (click)="loadPrevPage(); scrollIfNecessary(currentPage - 1)" [disabled]="loading">
            <mat-icon class="arrow pl-4">arrow_back_ios</mat-icon>
        </button>
        }

        @if (totalPages?.length > 1) {
            <div class="pages">
                @for (page of getVisiblePages(); track $index) {
                    <button mat-icon-button (click)="onPageClick(page)" [ngClass]="{ 'bg-primary': currentPage === page }"
                      class="page-number"
                      [disabled]="page === '...' || loading || (+page > 50 && +page > currentPage + 5)"
                    >
                      <p [ngClass]="{ 'text-accent': currentPage !== page }">
                        {{ page }}
                      </p>
                    </button>
                }
            </div>
        }

        @if (currentPage < totalPagesCount) { 
            <button class="arrow-btn" mat-icon-button (click)="loadNextPage(); scrollIfNecessary(currentPage + 1)"
            [disabled]="loading">
              <mat-icon class="arrow">arrow_forward_ios</mat-icon>
            </button>
            }
          }

        }
    </div>
</div>
